import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'autoHighlighter'
})
export class HighlighterPipe implements PipeTransform {
	transform (value: string, args1: string, args2 = false): string {
		if (value && args1 && !args2) {
			if (args1.toString().indexOf('+') === 0) {
				args1 = args1.toString().replace('+', '\\+');
			}
			return value.toString().replace(new RegExp('(' + args1 + ')', 'gi'), '<strong>$1</strong>');
		} else if (value && args1 && args2) {
			return value.toString().replace(new RegExp('(' + args1 + ')', 'i'), '<strong>$1</strong>');
		} else if (value) {
			return value;
		} else {
			return '';
		}
	}
}
